import { Theme } from '@mui/system';
import styled from '@mui/system/styled';

export const MoreAdvisorsCTAContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    '& .see-more-advisors': {
      marginTop: '20px'
    },
    '& .get-matched': {
      marginTop: '-16px',
      marginBottom: 0
    },
    '& a': {
      width: '100%',
      fontSize: '14px',
      fontWeight: 400,
      paddingTop: '12px',
      paddingBottom: '10px',
      borderColor: '#09b3b0',
      marginLeft: 0,
      '&:hover': {
        border: '1px solid #5fcac8',
        color: '#5fcac8',
        backgroundColor: 'transparent'
      }
    },
    '& .try-best-match': {
      marginTop: '8px',
      marginLeft: '-19px'
    },
    [theme.breakpoints.up('sm')]: {
      '& .see-more-advisors': {
        marginTop: '25px',
        marginLeft: '3px'
      },
      '& a': {
        padding: '16px 24px 14px',
        fontSize: '16px'
      },
      '& .get-matched': {
        marginTop: '24px',
        marginLeft: '-3px'
      }
    },
    [theme.breakpoints.up('md')]: {
      '& a': {
        marginTop: '29px !important'
      },
      '& .try-best-match': {
        marginTop: '12px'
      }
    },
    [theme.breakpoints.up('lg')]: {
      '& a': {
        marginTop: '31px !important'
      },
      '& .try-best-match': {
        marginTop: '14px'
      }
    }
  })
);

export default MoreAdvisorsCTAContainer;
